export default __webpack_public_path__ + "static/media/035-newlyweds.06ccbd3a.png";